import { NgFor } from '@angular/common';
import { Component } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
    selector: 'formly-account-percentage-repeat-section',
    template: `
		<div *ngFor="let field of field.fieldGroup; let i = index" [attr.class]="'row ' + to.innerRowClass">
			<formly-field class="col" [field]="field"></formly-field>
		</div>
		<div>
			<p>* The sum of percentage must be 100%</p>
		</div>
	`,
    standalone: true,
    imports: [NgFor, FormlyModule],
})
export class FormlyAccountPercentageRepeatComponent extends FieldArrayType {}
